import { GraphQLResponsePaginationInfo, GRAPHQL_TYPENAMES } from './types';

export const DEFAULT_PAGINATION_INFO: GraphQLResponsePaginationInfo = {
  __typename: GRAPHQL_TYPENAMES.INFO,
  count: 0,
  limit: 20,
  offset: 0,
  page: 1,
};
